/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
import React, { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import DetailAccountView from "../components/DetailAccountView";
import { accountActions } from "../../account/redux/actions";
import { TAccountState } from "../../account/utils/types";
import CircleLoading from "../components/CircleLoadding";
import AlertDialog from "../dialog/AlertDialog";
import { LIST_ACTION_CHECK_UPDATE_UI, LIST_ERROR_CODE_UPDATE_ACCOUNT_INFO } from "../../friends/utils/constant";
import { ERROR_CODE_NEED_LOGIN, LIST_ERROR_CODE_GIVE_DIAMOND } from "../utils/constant";
import { commonActions } from "../redux/actions";
import { handleGetAccountDetail } from "../utils/commonAPI";
import { TCommonState } from "../utils/type";
import { TFriendState } from "../../friends/utils/types";
import { friendActions } from "../../friends/redux/actions";

const AccountDetail = (props) => {
  const { memberHid, isFriendView } = props;
  const dispatch = useDispatch();
  const router = useRouter();
  const store = useStore();
  const [openModalGiftDiamond, setOpenModalGiftDiamond] = React.useState(false);
  const handleOpenModalGiftDiamond = () => {
    setOpenModalGiftDiamond(true);
  };
  const handleCloseModalGiftDiamond = () => {
    setOpenModalGiftDiamond(false);
  };
  const dataUser = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const { isLoading, infoAccount, notify } = useSelector((state: { account: TAccountState }) => state.account);
  const notifyFriend = useSelector((state: { friend: TFriendState }) => state.friend.notify);

  useEffect(() => {
    // handleGetAccountDetail(memberHid);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    return () => {
      dispatch(accountActions.handleClearDataAccountInfo());
      dispatch(accountActions.handleClearNotify());
    };
  }, []);
  useEffect(() => {
    if (LIST_ACTION_CHECK_UPDATE_UI.includes(notify?.type)) {
      handleGetAccountDetail(store, memberHid);
    }
    if (notify?.isOpenDialog && !LIST_ERROR_CODE_GIVE_DIAMOND?.includes(notify?.errorCode as string)) {
      dispatch(accountActions.handleClearDataAccountInfo());
    }
  }, [notify?.type]);

  return (
    <div className="text-black w-full overflow-hidden">
      {!dataUser?.member?.pub_id || notify.errorCode === "ENFINT" ? (
        <div className="h-screen bg-white rounded-md"></div>
      ) : isLoading ? (
        <div className="flex md:w-full sm:w-screen justify-center">
          <CircleLoading />
        </div>
      ) : (
        <DetailAccountView
          infoAccount={infoAccount}
          openModalGiftDiamond={openModalGiftDiamond}
          handleOpenModalGiftDiamond={handleOpenModalGiftDiamond}
          handleCloseModalGiftDiamond={handleCloseModalGiftDiamond}
          isFriendView={isFriendView}
        />
      )}
      {notify?.isOpenDialog && (
        <AlertDialog
          title={<FormattedMessage id="Setting.notification" />}
          open={notify?.isOpenDialog}
          setOpen={() => {}}
          triggerFunc={() => {
            if (notify.errorCode === ERROR_CODE_NEED_LOGIN) {
              dispatch(commonActions.handleOpenModalLogin({ isOpen: true }));
            }
            if (notify.type === "GIFT_DIAMOND_FAILED" && notify.errorCode === "ELPGDI") {
              handleCloseModalGiftDiamond();
              dispatch(accountActions.handleClearNotify());
            }

            if (notify?.errorCode) {
              if (LIST_ERROR_CODE_UPDATE_ACCOUNT_INFO.includes(notify?.errorCode)) {
                handleGetAccountDetail(store, memberHid);
              }
            }
            if (notify.errorCode === "ENFINT") {
              router.back();
              // dispatch(accountActions.handleClearNotify());
            } else {
              dispatch(accountActions.handleClearNotify());
            }
          }}
          styleContent={{ width: "100%", textAlign: "center" }}
          content={`${notify.message}(${notify.errorCode})`}
          buttonOkKey="common.ok"
          isHideCancel={!(notify.errorCode === ERROR_CODE_NEED_LOGIN)}
          cancelFunc={() => {
            router.back();
            dispatch(accountActions.handleClearNotify());
          }}
          notifyError
        />
      )}
      {notifyFriend?.isOpenDialog && (
        <AlertDialog
          open={notifyFriend?.isOpenDialog}
          setOpen={() => {
            dispatch(friendActions.handleClearNotify());
          }}
          title={<FormattedMessage id="Setting.notification" />}
          content={`${notifyFriend.message}(${notifyFriend?.errorCode})`}
          triggerFunc={() => {
            handleGetAccountDetail(store, memberHid);
            dispatch(friendActions.handleClearNotify());
          }}
          isHideCancel
          notifyError
        />
      )}
    </div>
  );
};

export default AccountDetail;
